import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, lastValueFrom, Observable } from 'rxjs';
import { ApiUrlService } from './api-url.service';
import {
  PartialUploadResponse,
  UploadControlResponse,
  UploadStatusDigitalRow,
  UploadStatusRow
} from '../models/interfaz';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  private uploadControlSubject = new BehaviorSubject<UploadControlResponse | undefined>(undefined);
  private uploadStatusDatabricksSubject = new BehaviorSubject<UploadStatusRow[] | undefined>(undefined);
  private uploadStatusDigitalDatabricksSubject = new BehaviorSubject<UploadStatusDigitalRow[] | undefined>(undefined);
  private partialUploadSubject = new BehaviorSubject<PartialUploadResponse | undefined>(undefined);

  constructor(private apiUrl: ApiUrlService, private http: HttpClient) {}

  get uploadControl(): BehaviorSubject<UploadControlResponse | undefined> {
    return this.uploadControlSubject;
  }

  get uploadStatusDatabricks(): BehaviorSubject<UploadStatusRow[] | undefined> {
    return this.uploadStatusDatabricksSubject;
  }

  get uploadStatusDigitalDatabricks(): BehaviorSubject<UploadStatusDigitalRow[] | undefined> {
    return this.uploadStatusDigitalDatabricksSubject;
  }

  get partialUpload(): BehaviorSubject<PartialUploadResponse | undefined> {
    return this.partialUploadSubject;
  }

  async getUploadControl(): Promise<Observable<UploadControlResponse | undefined>> {
    if (this.uploadControlSubject.value !== undefined) {
      return this.uploadControlSubject.asObservable();
    }
    const url = `${this.apiUrl.uploadControlApi}`;
    const datos = await lastValueFrom(this.http.get<UploadControlResponse>(url));
    this.uploadControlSubject.next(datos);
    return this.uploadControlSubject.asObservable();
  }

  getPartialUpload(): Observable<PartialUploadResponse> {
    const url = `${this.apiUrl.partialUploadApi}`;
    return this.http.get<PartialUploadResponse>(url);
  }

  async getUploadStatusDatabricks(): Promise<UploadStatusRow[]> {
    const url = `${this.apiUrl.uploadStatusDatabricksApi}`;
    const datos = await lastValueFrom(this.http.get<UploadStatusRow[]>(url));
    this.uploadStatusDatabricksSubject.next(datos);
    return datos;
  }

  async getUploadStatusDigitalDatabricks(): Promise<UploadStatusDigitalRow[]> {
    const url = `${this.apiUrl.uploadStatusDigitalDatabricksApi}`;
    const datos = await lastValueFrom(this.http.get<UploadStatusDigitalRow[]>(url));
    this.uploadStatusDigitalDatabricksSubject.next(datos);
    return datos;
  }
}
